import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by Surongmin"
      links={[
        {
          key: 'Code Craft',
          title: 'Code Craft',
          href: 'http://surongmin',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: 'https://gitlab.com/draft7080949/main-project',
          blankTarget: true,
        },
        {
          key: 'Document',
          title: 'Document',
          href: 'http://surongmin.com:8000',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
